import CalendarService from '../lib/services/CalendarService';

const fetchOptions = (params = {}, pageSize = 1000): Promise<any> => {
  const query = {
    ...params,
    pagesize: pageSize,
  };

  const Calendar = new CalendarService();

  return Calendar.getOptionActivitySignals(query).then(({ data }: any) => {
    if (Array.isArray(data.option_activity)) {
      return data.option_activity.filter((item: any) => item.cost_basis > 500000);
    }
  });
};

export { fetchOptions };
